export const calculateTotalPrice = (startDate: string, endDate: string, pricePerDay: number): number => {
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    if (start && end && start <= end) {
      const diffInTime = end.getTime() - start.getTime();
      const diffInDays = diffInTime / (1000 * 3600 * 24);
      const totalPrice = pricePerDay * diffInDays;
  
      return totalPrice > 0 ? totalPrice : 0;
    }
  
    return 0;
  };
  